export default {
  dashboard: "tableau de bord",
  month: "mois",
  active: "Actif",
  inactive: "Inactif",
  emptyList: "Cette liste est vide",
  true: "Oui",
  false: "Non",
  notFound: "Non trouvé",
  title: {
    editProfile: "Modifier mon profil",
    confirmDelete: "Confirmez la suppression",
    devInProgress: "Cette page est en cours de développement",
    users: "Users",
    editUser: "Edit user",
    addUser: "Add new user",
    scripts: "Scripts",
    executions: "Executions",
    refill: "Rechargement",
    refill_detail: "Détail du rechargement",
    defects: "Anomalies",
    changes: "Zippotage",
    logs_detail: "Logs",
  },
  button: {
    add: "Ajouter",
    dashboard: "Tableau de bord",
    scripts: "Scripts",
    cancel: "annuler",
    save: "enregistrer",
    signIn: "connexion",
    logOut: "Déconnexion",
    myProfile: "Mon profil",
    config: "Configuration",
    users: "Utilisateurs",
    settings: "Paramètres",
    ok: "OK",
    refill: "Rechargement",
    defects: "Anomalies",
    changes: "Zippotage",
  },
  menu: {
    reports: "Rapports",
    refill: "Rechargement",
    changes: "Zippotage",
    system: "Système",
    users: "Utilisateurs",
    scripts: "Scripts",
    defects: "Anomalies",
  },
  message: {
    notFound404: "Cette page n'existe pas, ou est en cours de développement!",
    confirmDeleteUser:
      "Voulez-vous vraiment supprimer définitivement cet utilisateur ?",
  },
  hint: {
    number: "Nombre",
    required: "Requis",
    minchar: "Min {chars} caractères",
    emailFormat: "Au format e-mail",
    password: "Mot de passe",
    repeatPassword: "Identique à mot de passe",
    requireLogin:
      "Il vous sera demandé de vous reconnecter avec les nouvelles informations afin de valider les changements.",
    numberLength: "Nombre à {chars} chiffres",
    newCodeCommentRequired: "Le commentaire est requis",
  },
  label: {
    password: "Mot de passe",
    email: "E-mail",
    username: "Utilisateur",
    search: "Rechercher",
    repeatPassword: "Confirmez le mot de passe",
    active: "Actif",
    roles: "Rôles",
    description: "Description",
    role: {
      admin: "Administrateur",
      super: "Super Admin",
      user: "Utilisateur",
    },
    name: "Nom",
    cron: "Cron",
    lastSuccessExecutionDate: "Dernier succes",
    lastExecutionDate: "Dernière execution",
    lastExecutionResult: "Etat",
    date: "Date",
    duration: "Durée",
    result: "Résultat",
    id: "ID",
    num_try: "Tentative",
    t_ok_before: "T.OK avant",
    t_ok_after: "T.OK après",
    refill_pending_after: "REFILL",
    not_seen_after: "Non vu après",
    diff_bu13: "Diff BU13",
    diff_pr13: "Diff PR13",
    diff_vi10: "Diff VI10",
    diff_cub5: "Diff CUB5",
    diff_cup5: "Diff CUP5",
    defect: "Anomalies",
    code: "Code",
    city: "Ville",
    original_id: "ID gb24",
    agent: "Mandataire",
    refill_date: "Date",
    numero: "Numero",
    stateBefore: "Avant rechargement",
    stateAfter: "Après rechargement",
    action: "Actions",
    defects: "Anomalies",
    total: "Total",
    defect_percentage: "Pourcentage",
    numEmpty: "Case vide en READY",
    numEmptyWithDoorOpen: "Dont porte ouverte",
    numLockerWithChanges: "Zippotage",
    numTheft: "Suspicion de vol",
    numTheftLast30Days: "Suspicion de vol (30 derniers jours)",
    locker: "Case",
    bottle_before: "Bouteille avant",
    bottle: "Bouteille",
    door_before: "Porte avant",
    door: "Porte",
    status_before: "Etat avant",
    status: "Etat",
    cause: "Raison detectée",
    summary: "Résumé",
    lastseen: "jusqu'au",
    openResult: "code ouverture",
    iem_conn_timeout: "Connexion timeout",
    iem_conn_failed: "Connexion échouée",
    iem_disconnected: "Déconnecté",
    iem_failed: "Echec",
    iem_door_ko: "Porte KO",
    iem_door_already_open: "Porte ouverte",
    iem_not_seen: "Non vues (borne)",
  },
  validation: {
    verify: "Veuillez corriger le formulaire",
    required: "Ce champ ne doit pas être vide",
    minchar: "Un minimum de {chars} caractères est requis",
    repeatPassword: "Les mots de passe doivent être identiques",
    isEmail: "Adresse e-mail non valable",
    number: "Ce champ doit être un nombre",
    positive: "Ce champs doit contenir un nombre positif",
    numberlength: "Ce champ doit être un nombre à {chars} chiffres",
  },
  tooltip: {
    editUser: "Modifier l'utilisateur",
    addUser: "Ajouter un utilisateur",
    deleteUser: "Supprimer définitivement l'utilisateur",
    execute: "Executer",
    viewScript: "Voir",
    viewLog: "Logs",
    id: "Identifiant unique de l'enregiement",
    original_id: "Identifiant original dans GB24",
    code: "Code du point de vente",
    city: "Ville où se trouve le point de vente",
    name: "Nom du point de vente",
    agent: "Nom du mandataire",
    date: "Date du rapport",
    numEmpty: "Nombre de cases vides en état READY",
    numEmptyWithDoorOpen: "Nombre de cases vides avec la porte ouverte",
    numTheft: "Nombre de suspicions de vol",
    numTheftLast30Days: "Nombre de suspicions de vol sur les 30 derniers jours",
    numLockerWithChanges: "Nombre de cases en cours de zippotage",
    num_tests: "Nombre de tentatives de rechargement",
    t_ok_before: "Nombre de serrure en Transaction OK avant le rechargement",
    t_ok_after: "Nombre de serrure en Transaction OK après le rechargement",
    not_seen_after: "Marge d'erreur. Ce sont les serrures qu'on n'a pas réussi à scanner depuis la dernière livraison",
    refill_pending_after: "Nombre de cases en attente de chargement",
    diff_bu13: "Différence de bouteilles BU13",
    diff_pr13: "Différence de bouteilles PR13",
    diff_vi10: "Différence de bouteilles VI10",
    diff_cub5: "Différence de bouteilles CUB5",
    diff_cup5: "Différence de bouteilles CUP5",
    defect: "Nombre d'anomalies détectées",
    iem_failed: "Nombre d'échecs de connexion lors du rechargement",
    iem_door_ko: "Nombre de portes en erreur",
    iem_not_seen: "Nombre de cases non vues lors du rechargement. (Attention, c'est une valeur déduite)",
    summary: "Résumé des erreurs",
  },
  action: {
    new: "Création",
    complete: "Finalisation",
  },

  api: {
    user: {
      profileUpdated: "Profil modifié",
      updated: "Utilisateur modifié",
      created: "User created",
      removed: "User removed",
    },
    login: { failure: "E-mail ou mot de passe invalide" },
  },
};
